const ths = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id'
  },
  {
    id: 2,
    label: 'First Name',
    intlKey: 'table.first_name'
  },
  {
    id: 3,
    label: 'Last Name',
    intlKey: 'table.last_name'
  },
  {
    id: 4,
    label: 'Email',
    intlKey: 'table.email'
  },
  /* {
    id: 5,
    label: 'Approval',
    intlKey: 'table.approval'
  },*/
  {
    id: 6,
    label: 'Child protection number',
    intlKey: 'table.child_protection_number'
  },
  {
    id: 7,
    label: 'Expire day',
    intlKey: 'table.expire_day'
  },
  {
    id: 8,
    label: 'Review',
    intlKey: 'table.review'
  },
  {
    id: 9,
    label: 'Action',
    intlKey: 'table.action'
  }
]

export default ths
